export default __webpack_public_path__ + "static/media/demander_une_intervention_humaine.644c2bc2.jpg";